// aliased
import angelListIcon from 'images/icons/angellist.svg';
import codewarsIcon from 'images/icons/codewars.png';
import facebookIcon from 'images/icons/facebook.svg';
import foursquareIcon from 'images/icons/foursquare.svg';
import githubIcon from 'images/icons/github.svg';
import goodreadsIcon from 'images/icons/goodreads.svg';
import instagramIcon from 'images/icons/instagram.png';
// import keybaseIcon from 'images/icons/keybase.svg';
import stackOverflowIcon from 'images/icons/stack-overflow.svg';
import linkedinIcon from 'images/icons/linkedin.svg';
import twitterIcon from 'images/icons/twitter.svg';

export default {
  linkedin: {
    icon: linkedinIcon,
    url: 'https://linkedin.com/in/colbydauphinais',
  },
  github: {
    icon: githubIcon,
    url: 'https://github.com/colbydauph',
  },
  instagram: {
    icon: instagramIcon,
    url: 'https://www.instagram.com/colbydauph/',
  },
  'angel list': {
    icon: angelListIcon,
    url: 'https://angel.co/colby-dauphinais',
  },
  codewars: {
    icon: codewarsIcon,
    url: 'https://codewars.com/users/colbydauph',
  },
  foursquare: {
    icon: foursquareIcon,
    url: 'https://foursquare.com/user/9435481',
  },
  goodreads: {
    icon: goodreadsIcon,
    url: 'https://www.goodreads.com/colbydauphinais',
  },
  'stack overflow': {
    icon: stackOverflowIcon,
    url: 'https://stackoverflow.com/users/2912714/colbydauph?tab=profile',
  },
  facebook: {
    icon: facebookIcon,
    url: 'https://facebook.com/colby.dauphinais',
  },
  twitter: {
    icon: twitterIcon,
    url: 'https://twitter.com/colbydauph',
  },
  // keybase: {
  //   icon: keybaseIcon,
  //   url: 'https://keybase.io/colbydauphinais',
  // },
};



// WEBPACK FOOTER //
// ./src/data/social-links.js